export default function removePropertiesTypeDeep(value: any): any {
  if (Array.isArray(value)) {
    return value.map(removePropertiesTypeDeep);
  }
  if (value !== null && typeof value === 'object') {
    const result: any = {};
    Object.entries(value).forEach(([key, val]) => {
      if (key === 'properties' && val !== null && typeof val === 'object') {
        const propertiesResult: any = {};
        Object.entries(val).forEach(([propKey, propVal]) => {
          if (propKey !== 'type') {
            propertiesResult[propKey] = removePropertiesTypeDeep(propVal);
          }
        });
        result[key] = propertiesResult;
      } else {
        result[key] = removePropertiesTypeDeep(val);
      }
    });
    return result;
  }
  return value;
}
